import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { SupplierItem, SupplierItemCreateDTO } from '../interfaces/procurement/supplierItem.interface';

export const SupplierItemService = {
  listBySupplier: async (supplierId: string): Promise<SupplierItem[]> =>
    (await axios.get(ENDPOINTS.SUPPLIER_ITEM.LIST_BY_SUPPLIER(supplierId))).data,
  listByInstitution: async (page = 0, size = 10) => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.SUPPLIER_ITEM.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  listByItem: async (itemId: string, page = 0, size = 20) => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(
      `${ENDPOINTS.SUPPLIER_ITEM.BY_ITEM(itemId)}?institutionId=${institutionId}&page=${page}&size=${size}`
    )).data;
  },
  getById: async (id: string): Promise<SupplierItem> =>
    (await axios.get(ENDPOINTS.SUPPLIER_ITEM.GET_BY_ID(id))).data,
  create: async (dto: SupplierItemCreateDTO): Promise<SupplierItem> =>
    (await axios.post(ENDPOINTS.SUPPLIER_ITEM.CREATE, dto)).data,
  update: async (id: string, dto: SupplierItemCreateDTO): Promise<SupplierItem> =>
    (await axios.put(ENDPOINTS.SUPPLIER_ITEM.UPDATE(id), dto)).data,
  delete: async (id: string): Promise<void> => { await axios.delete(ENDPOINTS.SUPPLIER_ITEM.DELETE(id)); },
};
